module.exports = __webpack_public_path__ + "static/media/Stunfisk_gaussian2.b7ed0939.png";